import nationalityRepository from '@app/api/repositories/nationality-repository'
import { host_without_last_slash } from '@app/constants/env'
import { IPathParams } from '@app/constants/path-params'
import { LOADING } from '@app/constants/redux-state'
import useLocalization from '@app/hooks/useLocalization'
import { IFileState } from '@app/interfaces/files'
import { INationality } from '@app/interfaces/nationality'
import { IPupilsState } from '@app/interfaces/pupil/pupils'
import AvatarForm from '@app/pages/pupils-page/components/pupil-page/components/avatar-form'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import { removeFile } from '@app/store/actions/files-actions'
import { getNationalities } from '@app/store/actions/nationality-actions'
import { clearPupil, getPupil } from '@app/store/actions/pupils-actions'
import { Card, Descriptions, Image, Spin } from 'antd'
import Text from 'antd/lib/typography/Text'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import RemoveAvatarForm from './components/remove-avatar-form'
import './pupil-page.less'

interface props {
  _pupilsState: IPupilsState
  _filesState: IFileState
  _nationalities: INationality[]
}

const PupilPage: React.FC<props> = ({
  _pupilsState,
  _filesState,
  _nationalities,
}) => {
  const { state, pupil } = _pupilsState
  const { photo, preUploadedPhoto } = _filesState
  const { localize } = useLocalization()
  const params: IPathParams = useParams()
  const [t] = useTranslation()
  const dispatch = useDispatch()
  useEffect(() => {
    const source = axios.CancelToken.source()
    dispatch(
      getPupil(
        { data: Number(params.pupilId), source: source },
        { pupilError: t('pupils.error'), fileError: t('users.errorAvatar') },
      ),
    )
    !isEmpty(_nationalities) &&
      nationalityRepository
        .getAll({ source })
        .then((response) => {
          dispatch(getNationalities(response.data))
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            openNotificationWithIcon('error', t('nationality.error'))
          }
        })
    return function cleanup() {
      dispatch(removeFile())
      dispatch(clearPupil())
      source.cancel('Component got unmounted')
    }
  }, [])

  const newMenu = (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
      }}>
      <AvatarForm
        pupil={pupil}
        avatar={preUploadedPhoto}
        edit={pupil?.fileId ? true : false}
      />

      {pupil?.fileId && (
        <RemoveAvatarForm pupil={pupil} avatar={preUploadedPhoto} />
      )}
    </div>
  )

  return (
    <>
      <Spin spinning={state === LOADING}>
        <Card title={t('pupils.pupil')}>
          <div className="avatar">
            <p>{t('users.avatar')}</p>
            {!isEmpty(photo) && pupil.fileId ? (
              <Image
                width={200}
                height={200}
                src={`${host_without_last_slash}/files${photo?.baseURL}/750x750-${photo?.filePath}`}
                style={{ border: '1px solid gray', background: 'gray' }}
              />
            ) : (
              <Image
                style={{ cursor: 'pointer' }}
                width={150}
                height={150}
                src="error"
                fallback="data:image/png;base64,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"
              />
            )}
            {newMenu}
          </div>

          <Descriptions size={'middle'} column={1} bordered>
            <Descriptions.Item label={t('pupils.id')}>
              {pupil.id}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.pin')}>
              {pupil.pin}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.fullName')}>
              {pupil.fullName}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.gender')}>
              {pupil.gender === 'MALE' ? t('pupils.male') : t('pupils.female')}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.birthDate')}>
              {pupil.birthDate}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.metric')}>
              {pupil.metric}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.socialProtection')}>
              {pupil.socialProtection ? t('general.yes') : t('general.no')}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.address')}>
              {pupil.address}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.orderNo')}>
              {pupil.orderNo}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.orderDate')}>
              {pupil.orderDate}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.benefit')}>
              {pupil.benefit ? t('general.yes') : t('general.no')}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.benefitType')}>
              {pupil.benefitType}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.applicationNo')}>
              {pupil.applicationNo}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.applicationDate')}>
              {pupil.applicationDate}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.directionDate')}>
              {pupil.directionDate}
            </Descriptions.Item>
            <Descriptions.Item label={t('pupils.governmentStake')}>
              {pupil.governmentStake ? t('general.yes') : t('general.no')}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Spin>
      {pupil.parents?.length ? (
        <Card style={{ marginTop: 20 }} title={t('pupils.parents')}>
          {pupil.parents?.map((data) => {
            return (
              <div key={data.id}>
                <Text className="pupil-parent-name">{t(data.fullName)}</Text>
                <Descriptions size={'small'} column={1} bordered>
                  <Descriptions.Item label={t('pupils.id')}>
                    {data.id}
                  </Descriptions.Item>
                  <Descriptions.Item label={t('pupils.pin')}>
                    {data.pin}
                  </Descriptions.Item>
                  <Descriptions.Item label={t('pupils.fullName')}>
                    {data.fullName}
                  </Descriptions.Item>
                  <Descriptions.Item label={t('parents.phone')}>
                    {data.phone}
                  </Descriptions.Item>
                  <Descriptions.Item label={t('nationality.title')}>
                    {_nationalities &&
                      localize(_nationalities).find((nationality) => {
                        return nationality.id === data.nationalityId
                      })?.data.name}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            )
          })}
        </Card>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    _pupilsState: state.pupils,
    _filesState: state.files,
    _nationalities: state.nationality.nationalities,
  }
}

export default connect(mapStateToProps)(PupilPage)
